var CODE_FIELDS, FIELDS_MAP, FIELDS_WITH_EDITOR_VALUE, FIELDS_WITH_SEMICOLON, REST_FIELDS, YES_NO_TEXT_FIELDS, exportAndSplitBySemicolon, exportCodes, exportGuideline, exportGuidelineFields, exportYesNoTextField, get, gradeProCodeToWHOCode, renderEditorValue, _ref;

_ref = require('lib/services/covid_exporter/utils'), exportAndSplitBySemicolon = _ref.exportAndSplitBySemicolon, exportGuidelineFields = _ref.exportGuidelineFields, exportYesNoTextField = _ref.exportYesNoTextField, gradeProCodeToWHOCode = _ref.gradeProCodeToWHOCode, renderEditorValue = _ref.renderEditorValue;

get = require('lodash').get;

YES_NO_TEXT_FIELDS = ['guidelineGroupDetails', 'consumerEngagement', 'peopleWithLivedExperience'];

CODE_FIELDS = ['guidelineInterventions', 'guidelinePopulations'];

FIELDS_MAP = {
  'fullReference': 'citation',
  'targetAudience': 'users'
};

FIELDS_WITH_SEMICOLON = ['source'];

FIELDS_WITH_EDITOR_VALUE = ['generalDescription', 'disclaimer', 'certaintyOfEvidenceTextInput', 'strengthOfRecommendationText'];

REST_FIELDS = ['authors', 'contactAddress', 'contactEmail', 'contactName', 'contactTelephone', 'contactWeb', 'countryFlag', 'department', 'doi', 'field', 'fullReference', 'gradebookChapter', 'institutionLogoUrl', 'institutionName', 'institutionShortName', 'isbn', 'issn', 'language', 'latestLiteratureSearchDate', 'linksAndVideos', 'oldGradebookLink', 'organizationType', 'owner', 'pmid', 'publicationDate', 'publishLastSearchDate', 'sourceDocumentLink', 'targetAudience', 'title', 'version', 'versionMajor', 'versionMinor'];

exportCodes = function(fieldValue) {
  if (_.isEmpty(fieldValue)) {
    return [];
  }
  return _.compact(_.map(fieldValue, function(_arg) {
    var codes, codesRaw, id, selected, value;
    id = _arg.id, value = _arg.value, selected = _arg.selected, codesRaw = _arg.codes;
    codes = _.chain(codesRaw).values().map(gradeProCodeToWHOCode).value();
    if (!selected) {
      return;
    }
    return {
      '@id': id,
      'name': value,
      'codes': codes
    };
  }));
};

exportGuideline = function(projectId, guidelineDoc) {
  var codesFields, fieldsWithDraftEditor, fieldsWithSemicolon, publicationYear, restFields, yesNoTextFields;
  publicationYear = guidelineDoc['publicationDate'] ? moment(guidelineDoc['publicationDate']).format('YYYY') : void 0;
  yesNoTextFields = exportGuidelineFields(exportYesNoTextField, YES_NO_TEXT_FIELDS, FIELDS_MAP, guidelineDoc);
  fieldsWithDraftEditor = exportGuidelineFields(renderEditorValue, FIELDS_WITH_EDITOR_VALUE, FIELDS_MAP, guidelineDoc);
  codesFields = _.chain(CODE_FIELDS).map(function(field) {
    return [field, exportCodes(guidelineDoc[field])];
  }).object().value();
  fieldsWithSemicolon = exportGuidelineFields(exportAndSplitBySemicolon, FIELDS_WITH_SEMICOLON, FIELDS_MAP, guidelineDoc);
  restFields = exportGuidelineFields(_.identity, REST_FIELDS, FIELDS_MAP, guidelineDoc);
  return _.extend({
    '@id': guidelineDoc['slug'],
    originalId: projectId,
    publicationYear: publicationYear
  }, fieldsWithSemicolon, yesNoTextFields, codesFields, fieldsWithDraftEditor, restFields);
};

module.exports = exportGuideline;
